import { HttpInterceptorFn } from '@angular/common/http';
import { isDevMode } from '@angular/core';
import { tap } from 'rxjs';
import { environment } from '../../../environments/environment';

export const gasLoggerInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isDevMode()) return next(req);

  const gasBase = environment.appsScriptUrl;
  if (!req.url.startsWith(gasBase)) return next(req);

  const action = req.urlWithParams.match(/[?&]action=([^&]+)/)?.[1] ?? req.method;
  const label = `[GAS] ${action}`;

  const body = req.body;
  if (body) {
    console.groupCollapsed(`${label} ← request`);
    console.log('URL', req.urlWithParams);
    try { console.log('Body', JSON.parse(body as string)); }
    catch { console.log('Body', body); }
    console.groupEnd();
  } else {
    console.log(`${label} ← GET`, req.urlWithParams);
  }

  const t0 = performance.now();
  return next(req).pipe(
    tap({
      next: (event: any) => {
        if (event?.body !== undefined) {
          const ms = Math.round(performance.now() - t0);
          console.groupCollapsed(`${label} → response (${ms} ms)`);
          console.log(event.body);
          console.groupEnd();
        }
      },
      error: (err) => {
        const ms = Math.round(performance.now() - t0);
        console.error(`${label} → error (${ms} ms)`, err);
      },
    }),
  );
};
